import About from "./About/About";
import Hero from "./Hero/Hero";
import Navigation from "./Navigation/Navigation";
import Technologies from "./Technologies/Technologies";

function App() {
  return (
    <>
      <Navigation />
      <Hero />
      <About />
      <Technologies />
    </>
  );
}

export default App;
